'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const MethodEnum = {
    Delete: 'DELETE',
    Get: 'GET',
    Post: 'POST',
    Put: 'PUT',
};

exports.MethodEnum = MethodEnum;
